<template>
  <div class="timeline-add">
    <h5>Your Progress</h5>
    <p>Ready, Set, Go!</p>
    <div class="timeline-area mt-4">
      <div v-for="(timeline, index) in timelines" :key="index" class="timeline-item" :class="[timeline.timelinesClass, timeline.isFilled ? 'filled' : '']">
        <span @click="redirect(timeline.heading)" :class="{'cursor-pointer': published == true}" >{{ timeline.heading }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "EventTimeline",
  props: {
    eventStep: Number,
    published: Boolean
  },
  data() {
    return {
      timelines: [
        {
          timelinesClass: "green",
          isFilled: false,
          heading: "Event Basics",
        },
        {
          timelinesClass: "dark",
          isFilled: false,
          heading: "Location",
        },
        {
          timelinesClass: "warning",
          isFilled: false,
          heading: "Date & time",
        },
        {
          timelinesClass: "blue",
          isFilled: false,
          heading: "Event Ticket",
        },
        {
          timelinesClass: "warning",
          isFilled: false,
          heading: "Publish",
        },
      ],
    };
  },
  methods: {
    redirect(redirect) {
      if(this.published){
        let eventId=null;
        if (window.sessionStorage.getItem("eventId")) {
          eventId = window.sessionStorage.getItem("eventId");
        }
        if (redirect == "Event Basics") {
          this.$router.push({ path: "/event/event-details" });
        }
        if (redirect == "Location") {
          this.$router.push({ path: "/event/event-location/"+eventId });
        }
        if (redirect == "Date & time") {
          this.$router.push({ path: "/event/event-series" });
        }
        if (redirect == "Event Ticket") {
          this.$router.push({ path: "/ticket/ticket-list" });
        }
        if (redirect == "Publish") {
          this.$router.push({ path: "/event/publish" });
        }
      }
    },
  },
  mounted() {
    this.timelines.map((data, i) => {
      if (i + 1 <= this.eventStep) {
        data.isFilled = true;
      }
    });
  },
};
</script>

